import ContactDirectory from '../../modules/contacts/directory/views/ContactDirectory.vue';
import CustomerInvoice from './CustomerInvoice.vue';
import CustomerManagement from './CustomerManagement.vue';
import DaycoRoleManagement from './DaycoRoleManagement.vue';
import Directory from '../../modules/contacts/directory/components/Directory.vue';
import DirectoryItem from '../../modules/contacts/directory/components/DirectoryItem.vue';
import ModalProfile from './ModalProfile.vue';
import PasswordRecovery from './PasswordRecovery.vue';
import BillsView from '@/modules/invoicing/views/BillsView.vue';
import CreateContactView from '@/modules/contacts/management/views/CreateContactView.vue';
export {
    ContactDirectory,
    CustomerInvoice,
    CustomerManagement,
    DaycoRoleManagement,
    Directory,
    DirectoryItem,
    ModalProfile,
    CreateContactView,
    PasswordRecovery,
    BillsView,
};
